<section class="domain-nameservers-container">
  <div class="warning-container" *ngIf="withError">
    <span>Domain isn’t pointed yet.</span> DNS records can take up to 24 hours to be resolved.<br>Please ensure there are no mistakes and check again later.
  </div>
  <div class="header">
    <div class="title" [innerHTML]="texts.title"></div>
    <div class="subtitle" *ngIf="!pointed" [innerHTML]="texts.subtitle"></div>
  </div>
  <div class="nameservers-list">
    <div class="nameserver-item" *ngFor="let nameserver of nameservers; let i = index">
      <div class="title">{{ 'text_addDomain.nameserver.label' | dbText: {number: i + 1} }}</div>
      <div class="nameserver-value">
        <div class="nameserver">{{nameserver}}</div>
        <div class="copy-value" ngxClipboard [cbContent]="nameserver" (cbOnSuccess)="copied(i)">
          @if(isCopied[i]){
          <i class="db-icon db-icon-ds-checkmark-sharp"></i>
          }@else{
          <span class="copy-link">
          Copy
          </span>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="action">
    <button class="ds-btn-black" (click)="close()"><span>Got it</span></button>
  </div>
</section>
